import type { InjectionKey } from 'vue'

export const FORM_ITEM_INJECTION_KEY = 'form-item-injection-key' as const
